import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class NotificationDAO {
  constructor(private readonly apiHelper: ApiHelper) {}

  public abandonBuyflow(userId: number): Observable<boolean> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/abandon-buyflow';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      userId: userId,
    };
    return this.apiHelper.apiCall<boolean>(url, method, null, data, headers);
  }

  private getResource(): string {
    return 'notification';
  }
}
